import _memoize from 'lodash/memoize'
import defaultLang from './default-lang'
import getLang from './default-lang'

interface Part {
  value: string
  type: string
}

const _getNumberFormat = (locale: string, fractionDigits: number): Intl.NumberFormat => {
  return new Intl.NumberFormat(locale, {
    maximumFractionDigits: fractionDigits,
    minimumFractionDigits: fractionDigits,
  })
}
const getNumberFormat = _memoize(_getNumberFormat, (...params) => params.join('-'))

export const formatNumberToParts = (value: number, locale: string = getLang(), fractionDigits = 2): Array<Part> => {
  return getNumberFormat(locale, fractionDigits).formatToParts(value)
}

const formatNumber = (value: number, locale = defaultLang(), fractionDigits = 2): string => {
  return getNumberFormat(locale, fractionDigits).format(value)
}

export default formatNumber
